<template>
  <component :is="routedComponent" :params="route.params" @route="onRoute"></component>
</template>

<script>
import i18n from '@/translations/i18n'
import utils from '@/utils'
import HomeView from '@/views/HomeView'
import FolderView from '@/views/FolderView'
import ArticleView from '@/views/ArticleView'
import TicketView from '@/views/TicketView'
import queryString from 'query-string'

const routes = {
  'HomeView': HomeView,
  'FolderView': FolderView,
  'ArticleView': ArticleView,
  'TicketView': TicketView
}

export default {
  props: {
    route: {
      type: Object,
      required: true
    }
  },

  computed: {
    routedComponent () {
      return routes[this.route.name]
    }
  },

  methods: {
    onRoute (route) {
      this.$emit('route', route)
    },
    clickHandler () {
      this.$root.$el.parentNode.addEventListener('click', (e) => {
        const link = e.target.closest('a')

        if (link === null) {
          return
        }

        const href = link.getAttribute('href')

        if (href === null) {
          return
        }

        e.preventDefault()

        // https://conf.fxclub.org/display/TP/Deeplinking
        if (href.includes('deeplink.html')) {
          window.handleOpenURL(`#${queryString.parseUrl(href).query.mobile}`)
        }

        // external links with target="_blank"
        if (e.target.target === '_blank') {
          if (window.cordova) {
            window.openSystemBrowser({url: href})
          } else {
            window.open(href, '_blank')
          }
        }

        // tickets/new
        if (href.includes('tickets/new')) {
          this.onRoute({name: 'TicketView'})
        }

        // articles/23000015584
        if (href.includes('articles')) {
          const articleId = href.split('/').pop()
          this.onRoute({name: 'ArticleView', params: {articleId: articleId}})
        }

        // folders/23000030476
        if (href.includes('folders')) {
          const folderId = href.split('/').pop()
          this.onRoute({name: 'FolderView', params: {folderId: folderId}})
        }
      })
    }
  },

  created () {
    const lang = utils.mapLangs(this.$lang)

    if (i18n.locale !== lang) {
      i18n.locale = lang
    }

    this.clickHandler()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Router.vue